import { render, staticRenderFns } from "./Markets.vue?vue&type=template&id=cb1376fa&scoped=true&"
import script from "./Markets.ts?vue&type=script&lang=ts&"
export * from "./Markets.ts?vue&type=script&lang=ts&"
import style0 from "./Markets.scss?vue&type=style&index=0&id=cb1376fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1376fa",
  null
  
)

export default component.exports